


























































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import scrollToError from '@/helpers/ScrollToError'
import TextEditor from '@/components/TextEditor/TextEditor.vue'
import ModalGroupTagSelect from '@/components/Modal/ModalGroupTagSelect.vue'
import ModalTopicSelectedFile from '@/components/Modal/ModalTopicSelectedFile.vue'
import ModalGroupMemberList from '@/components/Modal/ModalGroupMemberList.vue'
import {
  Topic,
  ETopicType,
  TopicAttachFile,
  ITinyEditorData,
  ETinyFileType,
  IdName,
  OptionSendMail,
  OptionGroupViewer,
  OptionGroupAuthority,
  CommentSettingMode,
  Member,
  Mentionable
} from '@/models'
import GroupTopicService from '@/services/GroupTopicService'
import CommonTopicService from '@/services/CommonTopicService'
//@ts-ignore
import _ from 'lodash'
import { checkScript } from '@/validations/validation'
import updateGroupMaxFileSize from '@/helpers/UpdateGroupMaxFileSize'
import GroupMemberService from '@/services/GroupMemberService'
import {
  allItemMention,
  allMentionCheckKeyword,
  filterMentions,
  getMentionIdsFromContent,
  handleSelectSuggestion
} from '@/helpers/Mentions'
import { ERR_API_KEY } from '@/constants'
import { removeHTML } from '@/helpers/Common'
import InputSearchMention from '@/components/InputSearchMention.vue'
import SearchMentionBox from '@/components/SearchMentionBox.vue'
import SelectedGroupTagVirtualList from '@/components/Group/SelectedGroupTagVirtualList.vue'

/**
 * f2-404
 * f2-404a
 * グループ掲示板のトピック作成
 * グループ 共通トピック作成
 */
@Component({
  components: {
    TextEditor,
    ModalGroupTagSelect,
    ModalTopicSelectedFile,
    ModalGroupMemberList,
    InputSearchMention,
    SearchMentionBox,
    SelectedGroupTagVirtualList
  }
})
export default class TopicCreate extends Vue {
  //check that this page is common topic or group
  isCommonTopic = !this.$route.params.groupId
  //check that this page is topic create or topic update
  isTopicCreate = !this.$route.params.topicId
  // NWS-1831 掲示板の削除はグループ管理者のみ（本文の変更を全員に許可していても開放しない）
  get roleDeleteTopic(): boolean {
    return !!this.$store.state.userInfo.user.group_role.role_admin
  }
  //lang for datepicker
  //modal helper
  modalMess: string = ''
  modalAction: any = () => {}
  //validate
  checkEmptyEditor: boolean = true
  overLengthContent: boolean = false
  includesScriptTagContent: boolean = false
  emptyContent: boolean = false
  disableCheckDate: boolean = false
  isScheduledDelivery: boolean = false
  maxFileSize: any = {
    mb: this.isCommonTopic
      ? 25
      : Number(this.$store.state.userInfo.user.current_group_max_file_size),
    bytes: this.isCommonTopic
      ? 25 * 1048576
      : Number(this.$store.state.userInfo.user.current_group_max_file_size) *
        1048576
  }
  //data
  createTopic: Topic = new Topic()
  private currentTopic: Topic = new Topic() //used for check before leave
  private originalAllowAnonymousComment = false
  groups: GroupNameVM[] = []
  selectedGroupTags: GroupNameVM[] = []
  private groupsLoaded = false
  isLoadingGroups = false
  private content_text: string = ''
  private tinyFileIds: number[] = []
  //files
  fileChooses: (File | TopicAttachFile)[] = []
  private currentFileChooses: (File | TopicAttachFile)[] = [] //used for check before leave
  chooseFileName: string = this.$t('common.form.not_selected') as string
  //enum
  eTopicType: any = ETopicType
  eTinyFileType: any = ETinyFileType
  //handle before leave
  private confirmLeave: any = () => {}
  private confirmLeaveIgnore: boolean = false
  optionSendMail: any = OptionSendMail
  optionViewer: any = OptionGroupViewer
  commentSettingModeEnum: any = CommentSettingMode
  public noAvatar = require('@/assets/images/avatar-default.png')
  maxSelectedDisplay = 10

  //mentions
  listToSearchMention: Mentionable[] = []
  listToSearchMentionWithBox: Mentionable[] = []
  listToSearchMentionWithBoxDefault: Mentionable[] = []
  private editorInstance: any
  isLoading: boolean = false

  listAdminGroup: Member[] = []

  getUserAvatarSmall(user: any): string {
    return user && user.user_profile && user.user_profile.avatar_small
      ? user.user_profile.avatar_small
      : ''
  }

  get commentSettingMode(): CommentSettingMode {
    const options = new Set((this.createTopic.topic_detail.comment_options || []).map(
      String
    ))
    if (options.has('1')) {
      return CommentSettingMode.ALL_USERS
    }
    if (options.has('3')) {
      return CommentSettingMode.ADMIN_ONLY
    }
    return CommentSettingMode.DISABLED
  }

  set commentSettingMode(mode: CommentSettingMode) {
    const detail = this.createTopic.topic_detail
    if (mode === CommentSettingMode.ALL_USERS) {
      detail.enable_comment = true
      detail.comment_options = detail.allow_anonymous_comment ? ['1', '2'] : ['1']
      return
    }
    if (mode === CommentSettingMode.ADMIN_ONLY) {
      detail.enable_comment = false
      if (this.isTopicCreate) {
      detail.allow_anonymous_comment = false
      }
      detail.comment_options = ['3']
      return
    }
    detail.enable_comment = false
    if (this.isTopicCreate) {
    detail.allow_anonymous_comment = false
    }
    detail.comment_options = []
  }

  @Watch('createTopic.topic_detail.allow_anonymous_comment')
  syncCommentOptionsFromAnonymous() {
    if (!this.isCommonTopic) {
      return
    }
    if (this.commentSettingMode !== CommentSettingMode.ALL_USERS) {
      return
    }
    const detail = this.createTopic.topic_detail
    detail.comment_options = detail.allow_anonymous_comment ? ['1', '2'] : ['1']
  }

  async fetchMention(keyword: string, shouldHandleLoading = false) {
    if (shouldHandleLoading) {
      this.isLoading = true
    }

    try {
      const groupId = this.$route.params.groupId

      let params: any = {
        groupId,
        page: 1,
        limit: this.$store.state.setting.setting.setting_display
          .number_item_lists,
        search: keyword,
        mention: true,
      }

      if (!this.isCommonTopic) {
        if (this.createTopic.topic_detail.option_viewer === OptionGroupViewer.AUTHORITY) {
          params.onlyAdmin = true
        } else if (this.createTopic.topic_detail.option_viewer === OptionGroupViewer.INDIVIDUAL) {
          params.userIds = this.createTopic.topic_detail.selected_members.map(item => item.id)
        }
      }

      const res = await GroupMemberService.getAllMembersByGroupId(params)

      if (res.status === 200 && res.data.data.length > 0) {
        return res.data.data.map((item: any) => ({
          id: item.id,
          name: item.name,
          avatar: this.getUserAvatarSmall(item)
        }))
      } else {
        return []
      }
    } finally {
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    }
  }

  async handleSearchMention({
    keyword,
    listTarget,
    closeDropdownFn,
    shouldHandleLoading
  }: {
    keyword: string
    listTarget: any[]
    closeDropdownFn?: () => void
    shouldHandleLoading?: boolean
  }) {
    const result = await this.fetchMention(keyword, shouldHandleLoading)

    if (
      result.length > 0 ||
      allMentionCheckKeyword.includes(keyword.toLowerCase()) ||
      !keyword
    ) {
      const newList: Mentionable[] = []

      if (allMentionCheckKeyword.includes(keyword.toLowerCase()) || !keyword) {
        newList.push(allItemMention)
      }

      if (result.length > 0) {
        newList.push(...result)
      }

      listTarget.splice(0, listTarget.length, ...newList)
    }

    if (
      result.length === 0 &&
      !allMentionCheckKeyword.includes(keyword.toLowerCase()) &&
      keyword
    ) {
      closeDropdownFn?.()
      this.onClearListWithDelay(listTarget)
    }
  }

  async onSearchMentionWithBox(keyword: string) {

    await this.handleSearchMention({
      keyword,
      listTarget: this.listToSearchMentionWithBox,
      shouldHandleLoading: true
    })
  }

  onClearListWithDelay(listTarget: Mentionable[]) {
    setTimeout(() => {
      listTarget.splice(0, listTarget.length)
    }, 200)
  }

  getEditorInstance(editor: any) {
    this.editorInstance = editor
  }

  onSelectMention(item: Mentionable) {
    handleSelectSuggestion({
      suggestion: item,
      editorInstance: this.editorInstance,
      insertFromOutside: true
    })

    const searchToMentionBoxRef = this.$refs.searchToMentionBoxRef as any
    if (searchToMentionBoxRef) {
      searchToMentionBoxRef.closeDropdown()
    }
  }

  private from: string = 'Topic Create'

  async created() {
    await this.checkTopicLock()
    this.checkRoleCommonTopic()
    this.hanldeTopicType()
    this.hanldeBindingTopic()
    this.handleMaxFileSize()

    if (!this.isCommonTopic) {
      const result = await this.fetchMention('')
      this.listToSearchMentionWithBoxDefault = [allItemMention, ...result]
      this.listToSearchMentionWithBox = [...this.listToSearchMentionWithBoxDefault]
    }
  }

  async handleMaxFileSize() {
    await updateGroupMaxFileSize(this.$route.params.groupId)
    this.maxFileSize = {
      mb: this.isCommonTopic
        ? 25
        : Number(this.$store.state.userInfo.user.current_group_max_file_size),
      bytes: this.isCommonTopic
        ? 25 * 1048576
        : Number(this.$store.state.userInfo.user.current_group_max_file_size) *
          1048576
    }
  }

  checkRouterBeforLeave() {
    if (this.isTopicCreate) {
      return (
        _.isEqual(this.createTopic, new Topic()) && !this.fileChooses.length
      )
    }
    return (
      _.isEqual(this.createTopic, this.currentTopic) &&
      _.isEqual(this.currentFileChooses, this.fileChooses)
    )
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    //this case for modal search header
    if (document.querySelectorAll('#modal-search-header').length) {
      next()

      //normal case
    } else if (!this.confirmLeaveIgnore && !this.checkRouterBeforLeave()) {
      this.confirmLeave = next
      this.$bvModal.show('topic-create-modal-confirm-leave')
    } else {
      this.hanldeConfirmLeave()
      next()
    }
  }

  hanldeConfirmLeave() {
    if (!this.isTopicCreate) {
      if (this.isCommonTopic) {
        CommonTopicService.unlockEditTopic(this.$route.params.topicId)
      } else {
        GroupTopicService.unlockEditTopic(
          this.$route.params.groupId,
          this.$route.params.topicId
        )
      }
    }
    this.confirmLeave()
  }

  handleTopicContentByOptionViewer(selectedMembers: Member[]) {
    const ids = selectedMembers.map(item => item.id)
    return filterMentions(this.createTopic.topic_detail.content, ids)
  }

  /**
   * Watch files choose to handle decriptions
   */
  @Watch('fileChooses')
  handleChooseFilesName() {
    this.checkEmptyEditor = !this.fileChooses.length
    this.emptyContent = this.fileChooses.length
      ? false
      : !this.checkPTagInner() && !this.content_text.trim()
    let name = this.$t('common.form.multi_selected', {
      count: this.fileChooses.length
    }) as string
    if (this.fileChooses.length === 0) {
      name = this.$t('common.form.not_selected') as string
      this.$bvModal.hide('display-files')
    }
    if (this.fileChooses.length === 1) {
      name = this.fileChooses[0].name
    }
    this.chooseFileName = name
  }

  @Watch('createTopic.topic_detail.option_viewer', { deep: true })
  async onOptionViewerChange() {
    if (this.isCommonTopic) {
      return
    }
    if (
      this.createTopic.topic_detail.option_viewer ===
      OptionGroupViewer.AUTHORITY
    ) {
      if (!this.listAdminGroup.length) {
        const response = await GroupMemberService.getAllMembersByGroupId({
          groupId: this.$route.params.groupId,
          limit: 0,
          onlyAdmin: true,
          page: 1
        })
        
        this.listAdminGroup = response.data.data
      }

      this.createTopic.topic_detail.content = this.handleTopicContentByOptionViewer(
        this.listAdminGroup
      )
    } else if (
      this.createTopic.topic_detail.option_viewer ===
      OptionGroupViewer.INDIVIDUAL
    ) {
      this.createTopic.topic_detail.content = this.handleTopicContentByOptionViewer(
        this.createTopic.topic_detail.selected_members
      )
    }
  }

  onSelectIndividualMember() {
    if (this.isCommonTopic) {
      return
    }
    this.$bvModal.show('group-member-list')
  }

  onRetrieveSelectedMember({
    selectedMembers,
    handleContent
  }: {
    selectedMembers: Member[]
    handleContent?: boolean
  }) {
    if (this.isCommonTopic) {
      return
    }
    this.createTopic.topic_detail.selected_members = selectedMembers

    if (handleContent) {
      this.createTopic.topic_detail.content = this.handleTopicContentByOptionViewer(selectedMembers)
    }
  }

  checkTopicLock() {
    if (this.isTopicCreate) {
      return
    }

    const lockRequest = this.isCommonTopic
      ? CommonTopicService.checkTopicLockByOther(this.$route.params.topicId)
      : GroupTopicService.checkTopicLockByOther(
          this.$route.params.groupId,
          this.$route.params.topicId
        )

    return lockRequest.catch(err => {
      if (err.response.status === 403 && err.response.data.is_locked) {
        this.confirmLeaveIgnore = true

        let name = err.response.data.is_locked_by.name
        const isHideGroupAdmin = err.response.data.hide_administrator || false

        if (isHideGroupAdmin) {
          name = this.$t('common.suffix.admin_2').toString()
        }

        this.modalMess = this.$t('common.message.topic_lock', {
          name
        }) as string
        this.modalAction = () => this.jumpToList()
        this.$bvModal.show('modal-info-topic-create')
      }
    })
  }

  checkTopicEditRole() {
    if (this.isCommonTopic) {
      if (!this.$store.state.userInfo.user.common_topic_role) {
        this.confirmLeaveIgnore = true
        this.jumpToList()
      }
    } else if (
        !this.createTopic.topic_detail.is_multiple_edit &&
        !this.$store.state.userInfo.user.group_role.role_edit_topic
      ) {
        this.confirmLeaveIgnore = true
        this.jumpToList()
      }
  }

  @Watch('$store.state.userInfo.user.common_topic_role')
  checkRoleCommonTopic() {
    if (
      this.isCommonTopic &&
      this.isTopicCreate &&
      !this.$store.state.userInfo.user.common_topic_role
    ) {
      this.confirmLeaveIgnore = true
      this.jumpToList()
    }
  }

  /**
   * Call API get topic detail when this is topic update page
   */
  hanldeBindingTopic() {
    if (!this.isTopicCreate) {
      if (this.isCommonTopic) {
        CommonTopicService.getCommonTopicById(this.$route.params.topicId)
          .then(res => {
            if (res.status === 200) {
              this.hanldeAfterBindingTopic(res)
            }
          })
          .catch(err => this.handleTopicNotFound(err))
      } else {
        GroupTopicService.getTopicById(
          this.$route.params.groupId,
          this.$route.params.topicId
        )
          .then(res => {
            if (res.status === 200) {
              this.hanldeAfterBindingTopic(res)
            }
          })
          .catch(err => this.handleTopicNotFound(err))
      }
    }
  }

  /**
   * Handle topic not found
   */
  handleTopicNotFound(err: any) {
    if (err.response.status === 404) {
      this.confirmLeaveIgnore = true
      this.modalMess = this.$t('common.message.topic_not_exist') as string
      this.modalAction = () => this.jumpToList()
    } else {
      this.modalMess = this.$t('common.message.uncatch_error') as string
      this.modalAction = () => {}
    }
    this.$bvModal.show('modal-error-topic-create')
  }

  /**
   * Bind data after call get detail topic successful
   */
  hanldeAfterBindingTopic(res: any) {
    this.createTopic = new Topic(res.data)
    this.isScheduledDelivery = true
     this.originalAllowAnonymousComment =
      this.createTopic.topic_detail.allow_anonymous_comment
    this.content_text = removeHTML(this.createTopic.topic_detail.content)
    this.checkTopicEditRole()
    this.fileChooses = this.createTopic.topic_detail.attach_file
    this.selectedGroupTags = this.createTopic.topic_detail.selected_group.map(
      item => new GroupNameVM(item, true)
    )
    const oldSelectedGroupTagIds = new Set(this.selectedGroupTags.map(item => item.id))
    this.groups.forEach(item => {
      item.selected = oldSelectedGroupTagIds.has(item.id)
    })
    this.currentTopic = _.cloneDeep(this.createTopic)
    this.currentFileChooses = _.cloneDeep(this.fileChooses)
  }

  /**
   * Handle topic tpye
   */
  hanldeTopicType() {
    this.createTopic.topic_detail.topic_type = this.isCommonTopic
      ? ETopicType.COMMON_TOPIC
      : ETopicType.GROUP_TOPIC

    if (this.isCommonTopic && this.isTopicCreate) {
      this.commentSettingMode = CommentSettingMode.ADMIN_ONLY
    }
  }

  /**
   * Get data from TextEditor
   */
  getEditorData(data: ITinyEditorData) {
    this.createTopic.topic_detail.content = data.html
    this.content_text = data.text
    this.tinyFileIds = data.fileIds
  }

  /**
   * Load group tags once when opening the select-group modal (common topic only).
   */
  initGroupTag(): Promise<void> {
    if (!this.isCommonTopic || this.groupsLoaded) {
      return Promise.resolve()
    }

    this.isLoadingGroups = true
    this.confirmLeaveIgnore = true

    return CommonTopicService.getAllGroupAdmin()
      .then(res => {
        if (res.status === 200) {
          this.groups = res.data.map((item: IdName) => {
            const getSeletedItem = this.selectedGroupTags.find(
              selected => selected.id === item.id
            )
            return new GroupNameVM(item, !!getSeletedItem)
          })
          this.groupsLoaded = true
        }
      })
      .catch(() => {
        this.modalMess = this.$t('common.message.uncatch_error') as string
        this.modalAction = () => {}
        this.$bvModal.show('modal-error-topic-create')
      })
      .finally(() => {
        this.isLoadingGroups = false
      })
  }

  openGroupSelectModal() {
    if (this.isCommonTopic && this.groupsLoaded) {
      this.isLoadingGroups = false
    }
    this.$bvModal.show('modal-group-tag-select')
    this.initGroupTag()
  }

  /**
   * Remove file by click 'x' in files display modal
   */
  removeFileFromFilesModal(index: number) {
    this.fileChooses = this.fileChooses.filter(
      (item: any, i: number) => i !== index
    )
  }

  /**
   * Handle select group tag
   */
  hanldeSelectedGroup(selected: GroupNameVM[]) {
    this.selectedGroupTags = selected
    this.groups.forEach(item => {
      item.selected = selected.map(i => i.id).includes(item.id)
    })
  }

  /**
   * Handle choose multiple file
   */
  onFileChange(event: any) {
    const files: File[] = event.target.files || event.dataTransfer.files
    if (!files.length) return
    if (this.fileChooses.length + files.length > 30) {
      this.modalMess = this.$t('common.message.over_30_file') as string
      this.modalAction = () => {}
      this.$bvModal.show('modal-info-topic-create-non-close')
      return
    }
    let fileterFile: File[] = []
    let haveSomeFileOverSize: boolean = false
    files.forEach(item => {
      if (item.size > this.maxFileSize.bytes) {
        haveSomeFileOverSize = true
      } else {
        fileterFile.push(item)
      }
    })
    if (haveSomeFileOverSize) {
      this.modalMess = this.$t('common.form.some_file_over_size', {
        max: this.maxFileSize.mb
      }) as string
      this.modalAction = () => {}
      this.$bvModal.show('modal-info-topic-create-non-close')
    }
    this.fileChooses = [...this.fileChooses, ...fileterFile];
    (this.$refs.textEditor as any).resetIsEmpty()
  }

  /**
   * Open modal to display all choosen files
   */
  openDisplayFiles() {
    if (this.fileChooses.length) this.$bvModal.show('display-files')
  }

  /**
   * Open modal confirm delete
   */
  deleteConfirm() {
    this.modalMess = this.$t('common.message.delete') as string
    this.$bvModal.show('modal-confirm-delete')
  }

  /**
   * Router jump to list
   */
  jumpToList() {
    this.isCommonTopic
      ? this.$router.push({ name: 'common-topic-new-feed' })
      : this.$router.push({ name: 'group-new-feed' })
  }

  /**
   * Router jump to list
   */
  jumpToListRoute() {
    return this.isCommonTopic
      ? { name: 'common-topic-new-feed' }
      : { name: 'group-new-feed' }
  }

  /**
   * Confirm modal press "Yes" handle
   */
  confirmDelete() {
    // NWS-1831 削除はグループ管理者のみ（会社お知らせは対象外・従来どおり）
    if (!this.isCommonTopic && !this.roleDeleteTopic) return
    this.$blockui.show()

    if (this.isCommonTopic) {
      CommonTopicService.deleteCommonTopic(this.$route.params.topicId)
        .then(res => {
          if (res.status === 200) {
            this.modalMess = this.$t('common.message.deleted') as string
            this.modalAction = () => this.jumpToList()
            this.$bvModal.show('modal-success-topic-create')
          }
        })
        .catch(err => this.handleDeleteErr(err))
        .finally(() => this.$blockui.hide())
    } else {
      GroupTopicService.moveTopicsToBin(this.$route.params.groupId, [
        Number(this.$route.params.topicId)
      ], this.from)
        .then(res => {
          if (res.status === 200) {
            this.modalMess = this.$t('common.message.deleted') as string
            this.modalAction = () => this.jumpToList()
            this.$bvModal.show('modal-success-topic-create')
          }
        })
        .catch(err => this.handleDeleteErr(err))
        .finally(() => this.$blockui.hide())
    }
  }

  handleDeleteErr(err: any) {
    if (
      err.response.status === 404 && [ERR_API_KEY.TOPIC_HAS_BEEN_DELETED, ERR_API_KEY.TOPIC_NOT_FOUND].includes(err.response.data.message)
    ) {
      this.modalMess = this.$t('common.message.topic_not_exist') as string
    } else {
      this.modalMess = this.$t('common.message.delete_fail') as string
    }
    this.modalAction = () => this.jumpToList()
    this.$bvModal.show('modal-error-topic-create')
  }

  /**
   * Convert data to formdata
   */
  formDataToSubmit(instantAction: boolean = false) {
    const formData = new FormData()
    const format = 'YYYY/MM/DD HH:mm:ss'
    const content = this.createTopic.topic_detail.content
    const multiEdit = this.createTopic.topic_detail.is_multiple_edit
    const emergencyContact = this.createTopic.topic_detail.emergency_contact
    const likeChar = this.createTopic.topic_detail.like_character_change?.trim()
    const deliveryDate = this.createTopic.topic_detail.delivery_date
    const deliveryDateMoment = this.moment(deliveryDate).format(format)
    const timeDeleteComments = this.createTopic.topic_detail
      .time_delete_comments
    const option_viewer = this.createTopic.topic_detail.option_viewer

    if (!this.isCommonTopic) {
      this.appendOptionViewerToFormData(formData, option_viewer)
    }

    formData.set('topic_type', String(this.createTopic.topic_detail.topic_type))
    formData.set('topic_title', this.createTopic.topic_detail.topic_title)
    formData.set('content', content || '')
    formData.set('content_text', this.content_text ? this.content_text : '')
    formData.set('is_multiple_edit', multiEdit ? '1' : '0')
    formData.set('emergency_contact', emergencyContact as any)
    formData.set('like_character_change', likeChar || '')
    formData.set('delivery_date', deliveryDateMoment)
    formData.set('time_delete_comments', timeDeleteComments || '')
    if (!this.isCommonTopic) {
      formData.set('option_viewer', option_viewer.toString())
    }

    if (instantAction) {
      formData.set('is_instant', '1')
    }

    this.appendHowNiceAndCommentOptionsToFormData(formData)
    this.appendAttachFilesToFormData(formData)

    this.tinyFileIds.forEach(id => {
      formData.append('file_ids[]', String(id))
    })

    this.appendCommonTopicOptionsToFormData(formData)
    this.appendMentionsToFormData(formData, content)

    return formData
  }

  private appendOptionViewerToFormData(
    formData: FormData,
    option_viewer: OptionGroupViewer
  ) {
    if (option_viewer === OptionGroupViewer.AUTHORITY) {
      formData.set('authority[]', OptionGroupAuthority.ADMIN.toString())
    }

    if (option_viewer === OptionGroupViewer.INDIVIDUAL) {
      const select_member_ids = this.createTopic.topic_detail.selected_members.map(
        member => member.id
      )
      select_member_ids.forEach(id => {
        formData.append('selected_members[]', id.toString())
      })
    }
  }

  private shouldAppendAnonymousComment(): boolean {
    if (!this.isTopicCreate) {
      return this.originalAllowAnonymousComment
    }
    return this.createTopic.topic_detail.allow_anonymous_comment
  }

  private appendHowNiceAndCommentOptionsToFormData(formData: FormData) {
    if (this.createTopic.topic_detail.enable_like || !this.isCommonTopic) {
      formData.append('how_nice[]', '1')
    }
    if (this.createTopic.topic_detail.hide_liker) {
      formData.append('how_nice[]', '2')
    }

    if (this.isCommonTopic) {
      if (this.commentSettingMode === CommentSettingMode.ALL_USERS) {
        formData.append('comment_options[]', '1')
        if (this.shouldAppendAnonymousComment()) {
          formData.append('comment_options[]', '2')
        }
      } else if (this.commentSettingMode === CommentSettingMode.ADMIN_ONLY) {
        formData.append('comment_options[]', '3')
        if (!this.isTopicCreate && this.shouldAppendAnonymousComment()) {
          formData.append('comment_options[]', '2')
        }
      } else if (!this.isTopicCreate && this.shouldAppendAnonymousComment()) {
        formData.append('comment_options[]', '2')
      }
    } else {
      if (this.createTopic.topic_detail.enable_comment) {
        formData.append('comment_options[]', '1')
      }
      if (this.createTopic.topic_detail.allow_anonymous_comment) {
        formData.append('comment_options[]', '2')
      }
    }
  }

  private appendAttachFilesToFormData(formData: FormData) {
    if (this.isTopicCreate) {
      this.fileChooses.forEach(file => {
        formData.append('attach_file[]', file as File)
      })
    } else {
      this.handleAttachFilesForUpdate(formData)
    }
  }

  private appendCommonTopicOptionsToFormData(formData: FormData) {
    if (!this.isCommonTopic) {
      return
    }
    formData.set(
      'hide_to_selected_group_tag',
      this.createTopic.topic_detail.hide_to_selected_group_tag ? '1' : '0'
    )
    this.selectedGroupTags.forEach(groupTag => {
      formData.append('selected_group[]', String(groupTag.id))
    })
  }

  private appendMentionsToFormData(formData: FormData, content: string) {
    const mentionAllId = allItemMention.id.toString()
    const uniqueMentionsIds = getMentionIdsFromContent(content)
    if (uniqueMentionsIds.length === 0) {
      return
    }
    uniqueMentionsIds
      .filter(id => id !== mentionAllId)
      .forEach(id => {
        formData.append('user_ids[]', id)
      })
    if (uniqueMentionsIds.includes(mentionAllId)) {
      formData.set('mention_all', 'true')
    }
  }

  /**
   * Handle convert fileChooses to delete_attach_file_ids[] and add_attach_files[]
   */
  handleAttachFilesForUpdate(formData: FormData) {
    this.fileChooses
      .filter((item: any) => !item.id)
      .map(file => {
        formData.append('add_attach_files[]', file as File)
      })

    const oldAttachFileIds: number[] = this.createTopic.topic_detail.attach_file.map(
      (item: any) => item.id
    )
    const keepFileIds: Set<number> = new Set(this.fileChooses
      .filter((item: any) => item.id)
      .map((item: any) => item.id))

    oldAttachFileIds
      .filter(id => !keepFileIds.has(id))
      .map(id => {
        formData.append('delete_attach_file_ids[]', String(id))
      })
  }

  /**
   * Submit create topic
   *
   * Call API submit form
   */
  async onSubmitCreateTopic(valid: boolean, instantAction: boolean = false) {
    if (this.handleContentError() && this.validateSelectGroupTag() && valid) {
      this.confirmLeaveIgnore = true
      this.disableCheckDate = true
      let formData = this.formDataToSubmit(instantAction)
      if (this.isCommonTopic) {
        if (this.isTopicCreate) {
          this.createCommonTopic(formData)
        } else {
          this.updateCommonTopic(formData)
        }
      } else if (this.isTopicCreate) {
          this.createGroupTopic(formData)
        } else {
          this.updateGroupTopic(formData)
        }
    } else {
      scrollToError(this.$refs, 'topicCreate')
    }
  }

  /**
   * Submit create topic and delivery now
   *
   * Call API create topic
   */
  submitAndUploadNow(valid: boolean) {
    let instantAction = true
    this.createTopic.topic_detail.delivery_date = new Date()
    ;(this.$refs as any).topicCreate.handleSubmit()
    setTimeout(() => {
      const errors = (this.$refs as any).topicCreate.errors
      delete errors.upload_date
      let valid = true
      for (const [, value] of Object.entries(errors)) {
        if ((value as any).length) {
          valid = false
          break
        }
      }
      this.onSubmitCreateTopic(valid, instantAction)
    }, 1)
  }

  /**
   * Call API to create new topic in common topic
   */
  createCommonTopic(formData: FormData) {
    this.$blockui.show()
    CommonTopicService.createCommonTopic(formData)
      .then(res => {
        if (res.status === 201) {
          this.modalMess = this.$t('common.message.created') as string
          this.modalAction = () => this.jumpToList()
          this.$bvModal.show('modal-success-topic-create')
        }
      })
      .catch(err => {
        this.submitError(err)
      })
      .finally(() => this.$blockui.hide())
  }

  /**
   * Call API to update topic in common topic
   */
  updateCommonTopic(formData: FormData) {
    this.$blockui.show()
    CommonTopicService.updateCommonTopic(this.$route.params.topicId, formData)
      .then(res => {
        if (res.status === 200) {
          this.modalMess = this.$t('common.message.updated') as string
          this.modalAction = () => this.jumpToList()
          this.$bvModal.show('modal-success-topic-create')
        }
      })
      .catch(err => {
        this.submitError(err)
      })
      .finally(() => this.$blockui.hide())
  }

  /**
   * Call API to create new topic in group topic
   */
  createGroupTopic(formData: FormData) {
    this.$blockui.show()
    GroupTopicService.createNewTopic(this.$route.params.groupId, formData)
      .then(res => {
        if (res.status === 201) {
          this.modalMess = this.$t('common.message.created') as string
          this.modalAction = () => this.jumpToList()
          this.$bvModal.show('modal-success-topic-create')
        }
      })
      .catch(err => {
        this.submitError(err)
      })
      .finally(() => this.$blockui.hide())
  }

  /**
   * Call API to update new topic in group topic
   */
  updateGroupTopic(formData: FormData) {
    this.$blockui.show()
    GroupTopicService.updateGroupTopic(
      this.$route.params.groupId,
      this.$route.params.topicId,
      formData
    )
      .then(res => {
        if (res.status === 200) {
          this.modalMess = this.$t('common.message.updated') as string
          this.modalAction = () => this.jumpToList()
          this.$bvModal.show('modal-success-topic-create')
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.modalMess = this.$t('common.message.topic_not_exist') as string
          this.modalAction = () => this.jumpToList()
        } else if (
          err.response.data.message === ERR_API_KEY.EXCEED_GROUP_STORAGE_CAPACITY
        ) {
          this.modalMess = this.$t('common.message.group_over_size') as string
          this.modalAction = () => {}
        } else if (err.response.status === 403) {
          if (
            err.response.data.message === ERR_API_KEY.LOCKED_BY_OTHER_USER &&
            err.response.data.is_locked_by
          ) {
            this.modalMess = this.$t('common.message.topic_edit_sesson_end', {
              name: err.response.data.is_locked_by.name
            }) as string
            this.modalAction = () => this.jumpToList()
          }
          if (err.response.data === 'topic_has_been_updated') {
            this.modalMess = this.$t(
              'common.message.topic_edited_by_other'
            ) as string
            this.modalAction = () => this.jumpToList()
          }
        } else {
          this.modalMess = this.$t('common.message.update_fail') as string
          this.modalAction = () => this.jumpToList()
        }
        this.$bvModal.show('modal-error-topic-create')
      })
      .finally(() => this.$blockui.hide())
  }

  /**
   * Handle call API create/update topic fail
   */
  submitError(err: any) {
    if (err.response.status === 404) {
      this.modalMess = this.$t('common.message.topic_not_exist') as string
      this.modalAction = () => this.jumpToList()
    } else if (err.response.data.message === ERR_API_KEY.EXCEED_GROUP_STORAGE_CAPACITY) {
      this.modalMess = this.$t('common.message.group_over_size') as string
      this.modalAction = () => {}
    } else if (
      err.response.status === 422 &&
      err.response.data.message === ERR_API_KEY.MAX_TOTAL_FILE_SIZE
    ) {
      this.modalMess = this.$t('common.message.upload_over_size', {
        max: err.response.data.upload_max_file_size
      }) as string
      this.modalAction = () => {}
    } else {
      this.modalMess = this.$t('common.message.update_fail') as string
      this.modalAction = () => this.jumpToList()
    }
    this.$bvModal.show('modal-error-topic-create')
    this.disableCheckDate = false
  }

  /**
   * Validation
   *
   * Validation for group tags
   */
  validateSelectGroupTag() {
    if (this.createTopic.topic_detail.topic_type === ETopicType.COMMON_TOPIC) {
      return this.selectedGroupTags.length !== 0
    }
    return true
  }

  /**
   * Validation
   *
   * Check content
   */
  handleContentError() {
    let returnVal = false
    if (
      !this.checkPTagInner() &&
      !this.content_text.trim() &&
      this.checkEmptyEditor
    ) {
      this.emptyContent = true
    } else if (
      new Blob([this.content_text]).size > 80000 ||
      _.toArray(this.content_text).length > 20000
    ) {
      this.overLengthContent = true
    } else if (checkScript(this.content_text)) {
      this.includesScriptTagContent = true
    } else {
      this.emptyContent = false
      this.overLengthContent = false
      returnVal = true
    }
    return returnVal
  }

  /**
   * Validation
   *
   * Validate min date
   */
  dateFormat(format?: string) {
    return format
      ? this.moment()
          .add(-1, 'second')
          .format(format)
      : this.moment().add(-1, 'second')
  }

  /**
   * Check that DOM inner text have another tag
   */
  checkPTagInner() {
    let tmp = document.createElement('DIV')
    tmp.innerHTML = this.createTopic.topic_detail.content
    const elmnt = tmp.getElementsByTagName('p')
    let innerTextofP = ''
    for (const element of elmnt) {
      const el = element
      innerTextofP = innerTextofP + el.innerHTML
      if (el.innerHTML.includes('<')) break
    }
    return innerTextofP.includes('<')
  }

  onInputNumberOnly(event: any) {
    const raw = event.target.value.replace(/[^0-9０-９]/g, '')

    const normalized = raw.replace(/[０-９]/g, (s: string) =>
      String.fromCodePoint((s.codePointAt(0) ?? 0) - 0xfee0)
    )

    const value = normalized.startsWith('0') ? '' : normalized
    event.target.value = value
    this.createTopic.topic_detail.time_delete_comments = value
  }

  onLikeCharacterChange(event: any) {
    // @ts-ignore
    const segmenter = new Intl.Segmenter("ja", { granularity: "grapheme" });

    function limitGraphemes(input: string, max: number) {
      const segs = [...segmenter.segment(input)];
      return segs.slice(0, max).map(s => s.segment).join("");
    }

    const val = event.target.value;
    const newVal = limitGraphemes(val, 10);

    if (newVal !== val) event.target.value = newVal;

    this.createTopic.topic_detail.like_character_change = newVal;
  }

  clearInputValue(event: Event) {
    const target = event.target as HTMLInputElement
    target.value = ''
  }
}

class GroupNameVM extends IdName {
  selected: boolean = false

  constructor(init?: IdName, selected?: boolean) {
    super()
    Object.assign(this, init)
    this.selected = !!selected
  }
}
